import React from 'react';
import {useTranslations} from 'next-intl';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {Grid} from '@/content/features/shared';
import {SectionPaddingHalf} from '@/section';
import {H3, PNoMargin} from '@/typography';
import {withBgNeutral200} from '@/hocs/withColors';
import {withMarginBottomZeroToLg} from '@/hocs/withSpacing';
import PictureWrapper from '@/ui/images-wrapper';
import ReviewBadge from '@/ui/review-badge';
import LinkComponent from '@/ui/links';
import styles from './styles.module.scss';

const BgSectionPaddingHalf = withBgNeutral200(SectionPaddingHalf);
const FeatureCol = withMarginBottomZeroToLg(Col);

const CARD_KEYS = ['card1', 'card2', 'card3'] as const;
type CardKey = (typeof CARD_KEYS)[number];

const imgPath = '/static/images/customers/';

const RecognisedSection = () => {
  const t = useTranslations('customers.recognisedSection');

  return (
    <BgSectionPaddingHalf className={styles.section}>
      <Container>
        <Grid fluid>
          <Row center="xs">
            <Col xs={12} md={10}>
              <h2 className={styles.title}>{t('title')}</h2>
            </Col>
          </Row>
          <Row className={styles['badges-row']}>
            {(['badge1', 'badge2', 'badge3', 'badge4'] as const).map(key => (
              <Col key={key} xs={12} md={3}>
                <ReviewBadge
                  logoSrc={t(`${key}.logoSrc`)}
                  logoAlt={t(`${key}.logoAlt`)}
                  score={t(`${key}.score`)}
                  starsVariant="green300"
                />
              </Col>
            ))}
          </Row>
          <Row center="xs" start="md">
            {CARD_KEYS.map((cardKey: CardKey) => (
              <FeatureCol key={cardKey} xs={12} md={4}>
                <article className={styles.card}>
                  <div className={styles.media}>
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl={t(`${cardKey}.imageUrl`)}
                      imageTypeFallback="jpg"
                      altImage={t(`${cardKey}.imageAlt`)}
                      className={styles.image}
                      loading="lazy"
                    />
                  </div>
                  <div className={styles.content}>
                    <H3>{t(`${cardKey}.title`)}</H3>
                    <PNoMargin>{t(`${cardKey}.description`)}</PNoMargin>
                  </div>
                </article>
              </FeatureCol>
            ))}
          </Row>
          <Row center="xs">
            <Col xs={12} className={styles.cta}>
              <LinkComponent href={t('ctaUrl')} target="_blank" variant="cta-default-xs">
                {t('ctaText')}
              </LinkComponent>
            </Col>
          </Row>
        </Grid>
      </Container>
    </BgSectionPaddingHalf>
  );
};

export default RecognisedSection;
